import { ReactNode } from "react";
import styled from "styled-components";

type StyledColProps = {
  width: string;
  align: "left" | "right";
  children?: ReactNode;
};

const StyledCol = styled.div<StyledColProps>`
  width: calc(${(props: StyledColProps) => props.width} - 25px);
  text-align: ${(props: StyledColProps) => props.align};
`;

type Props = {
  width: string;
  align?: "left" | "right";
  children?: ReactNode;
};
export default function Col({ children, width, align = "left" }: Props) {
  return (
    <StyledCol width={width} align={align}>
      {children}
    </StyledCol>
  );
}
